/**
 * Triggers a document download for the url.
 *
 * @param url: string url of the document to download.
 */
import { HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

export function downloadUrl(url: string, filename: string = 'download'): void {
    const link = document.createElement('a');
    link.setAttribute('target', '_self');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
}

/**
 * Calling `downloadUrl()` within the `next` function in a subscription makes that function return early,
 * so the following statements won't be executed. This wrapper returns an `Observable`, and later we subscribe
 * to it to continue with the rest of the procedure.
 *
 * @param url
 */
export function downloadUrlWrapper(url: string): Observable<any> {
    downloadUrl(url);
    return of({});
}

export const downloadFileFromPostResponse = (response: HttpResponse<Blob>): void => {
    const { headers } = response;
    const disposition = headers.get('content-disposition');
    const matches = /filename=([^;]+)/.exec(disposition!);

    if (!matches) {
        // Reload the page so the user is redirected to log in
        window.location.reload();
        return;
    }

    const filename = matches[1];
    const blob = response.body;
    const blobUrl = window.URL.createObjectURL(blob as Blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
};
